module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qStem"
  }, [_c('div', [_c('p', {
    staticClass: "qDescript",
    domProps: {
      "innerHTML": _vm._s(_vm.question.question_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-20"
  }, [(_vm.question.sid > -1 && _vm.moduleId != 15) ? _c('span', {
    staticClass: "queNum"
  }, [_vm._v(" " + _vm._s(_vm.question.sid + 1) + ". ")]) : _vm._e(), _vm._v(" "), (_vm.question.question_ref_sorce) ? _c('span', [_vm._v("(" + _vm._s(_vm.question.question_ref_sorce || 0) + "分, " + _vm._s(_vm.question.difficultyDegree) + "难度)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "qStemC"
  }, [_c('div', {
    staticClass: "qsamllStem",
    domProps: {
      "innerHTML": _vm._s(_vm.question.stem)
    }
  }), _vm._v(" "), _c('attachments', {
    attrs: {
      "attachments": _vm.question.attachments,
      "playerObj": _vm.playerObj,
      "id": _vm.question.id
    },
    on: {
      "playedObj": _vm.playedObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "option-box clearfix"
  }, _vm._l((_vm.question.options), function(option, opIndex) {
    return _c('div', {
      staticClass: "option-item"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("fromCharCode")(opIndex)) + ".")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(option.stem)
      }
    }), _vm._v(" "), _c('attachments', {
      attrs: {
        "attachments": option.attachments,
        "playerObj": _vm.playerObj,
        "id": _vm.question.id
      },
      on: {
        "playedObj": _vm.playedObj
      }
    })], 1)
  })), _vm._v(" "), (_vm.isShowAnswer) ? _c('div', [_c('div', {
    staticClass: "u-question-item"
  }, [_c('span', {
    staticClass: "color-999999"
  }, [_vm._v("学生答案：")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.setUserAnswer(_vm.question.options, _vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('div', {
    staticClass: "assessIconBox",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssessIcon(_vm.question.userAnswer))
    }
  }), _vm._v(" "), _c('span', [_vm._v("（"), _c('span', {
    staticClass: "col-red",
    domProps: {
      "innerHTML": _vm._s(_vm.setAssess(_vm.question.userAnswer))
    }
  }), _vm._v(" / " + _vm._s(parseFloat(_vm.question.question_ref_sorce)) + "分）")])])])]) : _vm._e(), _vm._v(" "), (_vm.moduleId == 15) ? _c('listenTabTopic', {
    attrs: {
      "infoAnswer": _vm.question,
      "listenTextModule": _vm.question.textModule[0],
      "qtype": 2
    }
  }) : (_vm.moduleId == 124) ? _c('tabTopic', {
    attrs: {
      "isObject": false,
      "infoAnswer": _vm.question,
      "knowledgePoints": _vm.question.knowledge_points,
      "skillPoints": _vm.question.skill_points,
      "explains": _vm.question.explains,
      "qtype": 2,
      "tags": _vm.question.tags
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6d2ff433","hasScoped":false}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/question/multipleChoice.vue
// module id = 193
// module chunks = 1